/* LUNA DISTRICT — global.js
   Vanilla JS, no dependencies. Uses Shopify's Ajax Cart API + Section Rendering API.
   Every interactive element works without JS as a normal form/link fallback. */
(() => {
  const routes = window.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Drawers (menu + cart) ---------------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    $$('[aria-controls="' + id + '"]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    const f = $('[data-autofocus], button, a, input', d.querySelector('.drawer__panel'));
    setTimeout(() => f && f.focus(), 60);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    $$('[aria-controls="' + d.id + '"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); return; }
    const closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', e => {
    const open = $('.drawer.is-open');
    if (!open) return;
    if (e.key === 'Escape') closeDrawer(open);
    if (e.key === 'Tab') { // simple focus trap
      const f = $$('a[href], button:not([disabled]), input, select, textarea', open.querySelector('.drawer__panel')).filter(el => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- Header scroll state (overlay header over hero) ---------------- */
  const header = $('.site-header');
  if (header && header.classList.contains('site-header--overlay')) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- Cart (Ajax API + section rendering) ---------------- */
  const cartDrawerEnabled = !!document.getElementById('CartDrawer');

  function renderCartSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = $('#CartDrawerInner', html);
      const current = $('#CartDrawerInner');
      if (fresh && current) current.replaceWith(fresh);
    }
    if (sections['cart-count']) {
      const html = new DOMParser().parseFromString(sections['cart-count'], 'text/html');
      const n = $('[data-cart-count]', html);
      if (n) $$('[data-cart-count]').forEach(el => { el.textContent = n.textContent; el.dataset.count = n.dataset.count; });
    }
  }

  async function addToCart(form, button) {
    const msg = $('[data-form-message]', form.closest('[data-product]') || form);
    if (msg) msg.textContent = '';
    button && button.classList.add('is-loading');
    const fd = new FormData(form);
    fd.append('sections', 'cart-drawer,cart-count');
    fd.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added. Please try again.');
      renderCartSections(data.sections);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      openDrawer('CartDrawer');
    } catch (err) {
      if (msg) msg.textContent = err.message;
    } finally {
      button && button.classList.remove('is-loading');
    }
  }

  document.addEventListener('submit', e => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !cartDrawerEnabled) return; // without drawer, native POST to /cart/add redirects to cart
    e.preventDefault();
    addToCart(form, e.submitter || $('[type="submit"]', form));
  });

  async function changeLine(line, quantity, container) {
    container && container.classList.add('is-busy');
    try {
      const res = await fetch(routes.cart_change_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer', 'cart-count'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Could not update your bag.');
      renderCartSections(data.sections);
      if (document.body.classList.contains('template-cart')) window.location.reload();
    } catch (err) {
      const box = $('[data-cart-error]');
      if (box) box.textContent = err.message;
    } finally { container && container.classList.remove('is-busy'); }
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    changeLine(parseInt(b.dataset.line, 10), parseInt(b.dataset.quantity, 10), b.closest('.cart-item'));
  });

  /* ---------------- Variant picker ---------------- */
  function money(cents) {
    const fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const v = (cents / 100).toFixed(2);
    const withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return withCommas;
    });
  }

  $$('[data-product]').forEach(root => {
    const json = $('script[data-variants]', root);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = form && $('input[name="id"]', form);
    const atc = form && $('[data-atc]', form);
    const atcLabel = atc && $('[data-atc-label]', atc);
    const qtyInput = form && $('input[name="quantity"]', form);
    const updateUrl = root.dataset.updateUrl === 'true';
    let currentVariant = variants.find(v => String(v.id) === (idInput && idInput.value)) || variants[0];

    function selected() { return $$('fieldset[data-option] input:checked', root).map(i => i.value); }

    function priceFor(v) {
      const q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      return { price: v.price * q, compare: v.compare_at_price ? v.compare_at_price * q : 0, q };
    }

    function paint() {
      const v = currentVariant;
      $$('[data-option-value-label]', root).forEach((el, i) => { el.textContent = selected()[i] || ''; });
      if (!v) {
        if (atc) { atc.disabled = true; atcLabel.textContent = atc.dataset.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      const p = priceFor(v);
      $$('[data-price]', root).forEach(el => (el.textContent = money(p.price)));
      $$('[data-compare]', root).forEach(el => { el.textContent = p.compare > p.price ? money(p.compare) : ''; el.hidden = !(p.compare > p.price); });
      $$('[data-save]', root).forEach(el => {
        const ok = v.compare_at_price > v.price;
        el.hidden = !ok;
        if (ok) el.textContent = el.dataset.template.replace('[amount]', money((v.compare_at_price - v.price) * p.q));
      });
      if (atc) {
        atc.disabled = !v.available;
        atcLabel.textContent = v.available ? atc.dataset.available : atc.dataset.soldout;
      }
      // sticky bar mirrors
      $$('[data-sticky-price]').forEach(el => (el.textContent = money(p.price)));
      $$('[data-sticky-variant]').forEach(el => (el.textContent = v.title === 'Default Title' ? '' : v.title));
      const sBtn = $('[data-sticky-atc]');
      if (sBtn) sBtn.disabled = !v.available;
      // availability of other values
      $$('fieldset[data-option]', root).forEach((fs, idx) => {
        $$('input', fs).forEach(input => {
          const opts = selected(); opts[idx] = input.value;
          const match = variants.find(x => x.options.every((o, i) => o === opts[i]));
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      if (v.featured_media) document.dispatchEvent(new CustomEvent('variant:media', { detail: { mediaId: v.featured_media.id, root } }));
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', e => {
      if (e.target.closest('fieldset[data-option]')) {
        const opts = selected();
        currentVariant = variants.find(v => v.options.every((o, i) => o === opts[i]));
        paint();
      }
      if (e.target.matches('input[data-offer-qty]') && qtyInput) {
        qtyInput.value = e.target.dataset.offerQty;
        paint();
      }
      if (e.target === qtyInput) paint();
    });
    $$('[data-qty-step]', root).forEach(b => b.addEventListener('click', () => {
      if (!qtyInput) return;
      const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
      qtyInput.value = next;
      $$('input[data-offer-qty]', root).forEach(o => (o.checked = parseInt(o.dataset.offerQty, 10) === next));
      paint();
    }));
    paint();
  });

  /* ---------------- Gallery ---------------- */
  $$('[data-gallery]').forEach(g => {
    const track = $('.gallery__track', g);
    const slides = $$('.gallery__slide', g);
    const thumbs = $$('.gallery__thumb', g);
    const dots = $$('.gallery__dots span', g);
    if (!track || !slides.length) return;
    const go = i => track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (!en.isIntersecting) return;
        const i = slides.indexOf(en.target);
        thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i ? 'true' : 'false'));
        dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
        slides.forEach((s, j) => { const v = $('video', s); if (v && j !== i) v.pause(); });
      });
    }, { root: track, threshold: 0.6 });
    slides.forEach(s => io.observe(s));
    document.addEventListener('variant:media', e => {
      if (!g.closest('[data-product]') || g.closest('[data-product]') !== e.detail.root) return;
      const i = slides.findIndex(s => s.dataset.mediaId === String(e.detail.mediaId));
      if (i > -1) go(i);
    });
  });

  /* ---------------- Sticky add to cart ---------------- */
  const sticky = $('[data-sticky-bar]');
  const mainAtc = $('[data-product-main] [data-atc]');
  if (sticky && mainAtc) {
    document.body.classList.add('has-sticky-atc');
    const footer = $('.site-footer');
    let atcVisible = true, footerVisible = false;
    const update = () => {
      const show = !atcVisible && !footerVisible && !$('.drawer.is-open');
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('button, a', sticky).forEach(el => (el.tabIndex = show ? 0 : -1));
    };
    new IntersectionObserver(([en]) => { atcVisible = en.isIntersecting || en.boundingClientRect.top > 0; update(); }).observe(mainAtc);
    if (footer) new IntersectionObserver(([en]) => { footerVisible = en.isIntersecting; update(); }).observe(footer);
    $('[data-sticky-atc]', sticky).addEventListener('click', () => {
      const form = mainAtc.closest('form');
      if (form.requestSubmit) form.requestSubmit(mainAtc); else mainAtc.click();
    });
    update();
  }

  /* ---------------- Before / after slider ---------------- */
  $$('[data-ba]').forEach(ba => {
    const r = $('input[type="range"]', ba);
    const set = () => ba.style.setProperty('--pos', r.value + '%');
    r.addEventListener('input', set); set();
  });

  /* ---------------- Lazy autoplay for muted loop videos ---------------- */
  const autoVids = $$('video[data-autoplay]');
  if (autoVids.length) {
    const vio = new IntersectionObserver(entries => entries.forEach(en => {
      const v = en.target;
      if (en.isIntersecting) {
        if (!v.src && v.dataset.src) { v.src = v.dataset.src; }
        if (!reduceMotion) v.play().catch(() => {});
      } else v.pause();
    }), { rootMargin: '200px 0px' });
    autoVids.forEach(v => vio.observe(v));
  }

  /* ---------------- Collection sort ---------------- */
  $$('select[data-sort]').forEach(s => s.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }));
  $$('[data-filter-form] input').forEach(i => i.addEventListener('change', () => i.form.submit()));

  /* ---------------- Recommendations (Complete your setup) ---------------- */
  $$('[data-recommendations]').forEach(async el => {
    try {
      const res = await fetch(el.dataset.url);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const inner = $('[data-recommendations]', html);
      if (inner && inner.innerHTML.trim().length && $('.card', inner)) el.innerHTML = inner.innerHTML;
      else el.closest('.shopify-section') && (el.closest('.shopify-section').hidden = true);
    } catch (e) { /* silent: section simply stays hidden */ }
  });

  /* ---------------- Order tracking helper ---------------- */
  $$('[data-track-form]').forEach(f => f.addEventListener('submit', e => {
    e.preventDefault();
    const n = $('input[name="tracking"]', f).value.trim().replace(/\s+/g, '');
    if (!n) return;
    const base = f.dataset.trackBase || 'https://t.17track.net/en#nums=';
    window.open(base + encodeURIComponent(n), '_blank', 'noopener');
  }));
})();
